import React from 'react';

interface MacroSummaryProps {
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
  showPercentages?: boolean;
}

export function MacroSummary({
  calories,
  protein,
  carbs,
  fat,
  showPercentages = false,
}: MacroSummaryProps) {
  const total = protein + carbs + fat;
  const proteinPercentage = (protein / total) * 100;
  const carbsPercentage = (carbs / total) * 100;
  const fatPercentage = (fat / total) * 100;

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium">🔥 {calories} cal</span>
      </div>
      <div className="h-6 w-full bg-gray-100 rounded-full overflow-hidden">
        <div className="h-full flex">
          <div
            className="bg-red-100 h-full flex items-center justify-center"
            style={{ width: `${proteinPercentage}%` }}
          >
            {proteinPercentage > 10 && <span className="text-red-800 text-xs">🥩</span>}
          </div>
          <div
            className="bg-yellow-100 h-full flex items-center justify-center"
            style={{ width: `${carbsPercentage}%` }}
          >
            {carbsPercentage > 10 && <span className="text-yellow-800 text-xs">🍞</span>}
          </div>
          <div
            className="bg-green-100 h-full flex items-center justify-center"
            style={{ width: `${fatPercentage}%` }}
          >
            {fatPercentage > 10 && <span className="text-green-800 text-xs">🥑</span>}
          </div>
        </div>
      </div>
      <div className="flex justify-between text-xs">
        <div className="flex flex-col items-start">
          <span className="text-red-800">Protein</span>
          <span>
            {protein.toFixed(1)}g {showPercentages && `(${Math.round(proteinPercentage)}%)`}
          </span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-yellow-800">Carbs</span>
          <span>
            {carbs.toFixed(1)}g {showPercentages && `(${Math.round(carbsPercentage)}%)`}
          </span>
        </div>
        <div className="flex flex-col items-end">
          <span className="text-green-800">Fat</span>
          <span>
            {fat.toFixed(1)}g {showPercentages && `(${Math.round(fatPercentage)}%)`}
          </span>
        </div>
      </div>
    </div>
  );
}
